import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ApplicationConfirmationDialogData, ApplicationConfirmationDialogResult} from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { FlexModule } from '@angular/flex-layout/flex';
import { MessageBoxComponent } from '../message-box/message-box.component';


@Component({
    templateUrl: './application-confirmation.dialog.html',
    styleUrls: ['./application-confirmation.dialog.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, FlexModule, MatCheckboxModule, MatButtonModule, MatDialogModule, MessageBoxComponent]
})
export class ApplicationConfirmationDialog {

  step: 1 | 2 = 1;
  formGroup: FormGroup<{}>;
  consentFormGroup: FormGroup<{}>;
  messagesAndControls: {m: ApplicationConfirmationDialogData['messages'][number], c: FormControl}[] = [];
  individualsAndControls: {individual: NonNullable<ApplicationConfirmationDialogData['individuals']>[number], c: FormControl}[] = [];
  hasConsentStep = false;

  constructor(@Inject(MAT_DIALOG_DATA) data: ApplicationConfirmationDialogData,
              private dialogRef: MatDialogRef<ApplicationConfirmationDialog, ApplicationConfirmationDialogResult>,
              private formBuilder: FormBuilder) {
    this.formGroup = this.formBuilder.group({});
    this.consentFormGroup = this.formBuilder.group({});
    for (const message of data.messages) {
      const formControl = this.formBuilder.control(false, [Validators.requiredTrue]);
      this.formGroup.addControl(message.id, formControl);
      this.messagesAndControls.push({m: message, c: formControl});
    }
    for (const individual of (data.individuals ?? [])) {
      const formControl = this.formBuilder.control(false, [Validators.requiredTrue]);
      this.consentFormGroup.addControl(individual.id, formControl);
      this.individualsAndControls.push({individual, c: formControl});
    }
    this.hasConsentStep = this.individualsAndControls.length > 0;
  }

  onNext($event: MouseEvent) {
    $event.preventDefault();
    if (this.formGroup.invalid || !this.hasConsentStep) {
      return;
    }
    this.step = 2;
  }

  onBack($event: MouseEvent) {
    $event.preventDefault();
    this.step = 1;
  }

  onSubmit($event: MouseEvent) {
    const result: ApplicationConfirmationDialogResult = {
      readyForSubmission: false
    };
    const messagesReady = this.messagesAndControls.reduce((s , curr) => {
      result[curr.m.id] = curr.c.value;
      return s && curr.c.value;
    }, true);
    const consentReady = !this.hasConsentStep || this.individualsAndControls.reduce((s, curr) => {
      result[curr.individual.id] = curr.c.value;
      return s && curr.c.value;
    }, true);
    result.readyForSubmission = messagesReady && consentReady;

    this.dialogRef.close(result);
  }

  onCancel($event: MouseEvent) {
    const result: ApplicationConfirmationDialogResult = {
      readyForSubmission: false
    };
    this.messagesAndControls.forEach(curr => {
      result[curr.m.id] = curr.c.value;
    });
    this.individualsAndControls.forEach(curr => {
      result[curr.individual.id] = curr.c.value;
    });

    this.dialogRef.close(result);
  }
}
